import {FlickerController} from "@luciad/ria/view/controller/FlickerController";
import {Map} from "@luciad/ria/view/Map";
import React, {useEffect, useState} from "react";
import {ControllerInstructions} from "./ControllerInstructions";
import "./FlickerUI.css";
import {LayerPicker} from "./LayerPicker";

interface Props {
  map: Map;
  controller: FlickerController;
}

export const FlickerUI = ({map, controller}: Props) => {
  const [isInstructionsVisible, setInstructionsVisible] = useState(true);
  const [leftLayersVisible, setLeftLayersVisible] = useState(
      controller.visibleIndex === 0
  );

  useEffect(() => {
    const initialFlickerListener = controller.on("VisibleIndexChange", () => {
      setInstructionsVisible(false);
      initialFlickerListener.remove();
    });

    const visibleIndexListener = controller.on("VisibleIndexChange", i => {
      setLeftLayersVisible(i === 0);
    });

    return () => {
      initialFlickerListener.remove();
      visibleIndexListener.remove();
    };
  }, []);

  return (
      <>
        <ControllerInstructions visible={isInstructionsVisible}>
          Left click to cycle between layer sets.
        </ControllerInstructions>
        <LayerPicker
            map={map}
            controller={controller}
            leftContainerClass={leftLayersVisible ? undefined : "lcd-flicker-disabled"}
            rightContainerClass={leftLayersVisible ? "lcd-flicker-disabled" : undefined}
        />
      </>
  );
};
